import {
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  Tooltip,
} from '@mui/material';

import { FC, useCallback, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useBooking, useDialog, useSnack } from '@/logic/state';

import CheckIcon from '@mui/icons-material/Check';
import Icon24 from '@/components/shared/icon-24';

import shallow from 'zustand/shallow';
import { CloseButton } from '@/components/shared/close-button';
import ImageBoxFuture from '@/components/shared/image-box-future';

const ShareWhiteIcon = '/icons/shared/share-white.svg';

export const ShareSeatsPlanDialog: FC = () => {
  const [isLinkCopied, setIsLinkedCopied] = useState(false);
  const intl = useIntl();
  const booking = useBooking(s => s.booking, shallow);
  const setDialog = useDialog(s => s.setDialog, shallow);
  const setSnack = useSnack(s => s.setSnack, shallow);

  const handleShareSeatsPlanClick = useCallback(() => {
    navigator.clipboard
      .writeText(booking.seatsPlanImageUrl)
      .then(() => {
        setIsLinkedCopied(true);
        setTimeout(() => setIsLinkedCopied(false), 1000);
      })
      .catch(() => {
        setSnack({
          isOpen: true,
          message: 'booking.share_seats_plan.copy_link.fail',
          type: 'error',
        });
      });
  }, [booking.seatsPlanImageUrl, setSnack]);

  return (
    <>
      <DialogTitle>
        <CloseButton handleClick={() => setDialog({})} />
      </DialogTitle>
      <DialogContent>
        <ImageBoxFuture
          img={booking?.seatsPlanImageUrl}
          title={intl.formatMessage({
            id: 'booking.seats_plan_image',
          })}
          objectFit='contain'
          sx={{
            width: '100%',
            height: '300px',
          }}
        />
      </DialogContent>
      <DialogActions
        sx={{
          justifyContent: 'center',
        }}
      >
        <Tooltip
          title={
            <FormattedMessage
              id={
                isLinkCopied
                  ? 'booking.share_seats_plan.click'
                  : 'booking.share_seats_plan.hover'
              }
            />
          }
        >
          <Button
            id='share-seats-plan-dialog-share-btn'
            variant='secondary'
            startIcon={
              isLinkCopied ? (
                <CheckIcon sx={{ fontSize: '24px !important' }} />
              ) : (
                <Icon24 icon={ShareWhiteIcon} title='alt.share_ticket_icon' />
              )
            }
            onClick={handleShareSeatsPlanClick}
          >
            <FormattedMessage id='booking.share_seats_plan' />
          </Button>
        </Tooltip>
      </DialogActions>
    </>
  );
};
